import { Component, OnInit } from '@angular/core';
import {
  ActivatedRoute,
  Router,
  ActivatedRouteSnapshot,
  NavigationEnd
} from '@angular/router';
import Swal from 'sweetalert2';
import { LeftNavigationService } from './../../services/left-navigation.service';
import { Subscription } from 'rxjs/Subscription';
import {
  ClubProgram, Observable, AppState, Store, AppFields, AppTypes, ProgramsBillingType, map, AutoUnsubscribe, Organization, OrgTeam,
  switchMap, filter, take, StorageUtil, InputUtil, ProgramsBillingName, ProgramsBaseUrl, EStaffRoles, combineLatest
} from '../../store';
import { environment } from '../../../environments/environment';
import { UserInfo } from '../../interfaces';
import { Fields } from '../../pages/association-registration/store';
import { AssociationRegistrationService, PlayerAdjustmentService, ClubEventsService, AlertService } from '../../services';
import { CollegeRecrutingCenterService } from '../../services/college-recruiting-center.service';
import * as lodash from 'lodash';

@Component({
  selector: 'app-nav-left',
  templateUrl: './nav-left.component.html',
  styleUrls: ['./nav-left.component.css']
})
@AutoUnsubscribe
export class NavLeftComponent implements OnInit {
  public currentUrl = '';
  public urlRedirect =
    'https://admin.totalglobalsports.com/ClubDirector/ClubDashboard.aspx';
  public routeParams;
  public subscription: Subscription = new Subscription();
  public isOpenClubBillingMenu = false;
  public ProgramId: any;
  public ProgramTypeId: any;
  public ProgramName: any;
  public ProgramStatus: any;

  menuOpened = [];
  teamAccount = false;
  isTeamAccount = false;
  staffEvaluations: Observable<boolean>;

  program: ClubProgram;
  public myTeam;
  public collegeRecPlayer;
  typeId: number;
  user: Observable<UserInfo>;

  programsOpened: boolean;
  clubCalendarOpened: boolean;
  evaluationsOpened: boolean;
  collegeRecruitingOpened: boolean;
  collegeAttendanceOpened: boolean;
  clubOpened: boolean;
  healthOpened: boolean;
  injurySelected: boolean;
  evaluationTemplatesSelected: boolean;
  developmentCalendarSelected: boolean;
  moodSelected: boolean;
  gameSurveySelected: boolean;
  developmentCalendarOpened: boolean;
  currentSeason: boolean;
  pastSeason: boolean;
  workoutsOpened: boolean;
  teamsOpened: boolean;
  communicationCenterOpened: boolean;
  associationRegistration: boolean;
  associationRegistrationOpened: boolean;
  emailCampaignCommunicationOpened: boolean;
  clubMobileCommunicationOpened: boolean;
  communicationEmail: boolean;
  teamSchedulePage: boolean;
  recruitingCenterOpened: boolean;
  clubEventsOpened: boolean;
  financialsOpened: boolean;
  financialProgramOpened: boolean;
  financialEventsOpened: boolean;
  financialFacilitiesOpened: boolean;
  financialPlayersOpened: boolean;
  collegeCenterOpened: boolean;
  teamCollegeRecruitingOpened: boolean;
  collegeCheckInOpened: boolean;
  videoCenterOpened: boolean;
  isSafeSportInfo: boolean;
  isSafeSportInfoPlayer: boolean;
  isSafeSportInfoStaff: boolean;

  selectedOrg: Observable<Organization>;
  selectedPastOrg: Observable<Organization>;
  selectedTeam: Observable<OrgTeam>;
  selectedOrgSeason: any;

  isChildClub: boolean;
  isBasketballClub: boolean;
  teamProgramsOpened = true;
  isECNLEventClub: boolean;
  clubHasCollegeRecruitingPlan: Observable<any>;
  subscriptionPlans: any;
  clubPlans: any;
  teamPlans: any;
  //clubTeamHasCollegeRecruitingPlan: Observable<any>;
  selectedWorkoutPlanUrl;

  billingMenus = [
    { type: ProgramsBillingType.ClubBilling, baseUrl: ProgramsBaseUrl[ProgramsBillingType.ClubBilling] + '/programs', name: ProgramsBillingName[ProgramsBillingType.ClubBilling], icon: 'si si-credit-card', isClubBilling: true },
    { type: ProgramsBillingType.TeamBilling, baseUrl: ProgramsBaseUrl[ProgramsBillingType.TeamBilling] + '/programs', name: ProgramsBillingName[ProgramsBillingType.TeamBilling], icon: 'si si-tag' },
    { type: ProgramsBillingType.TravelBilling, baseUrl: ProgramsBaseUrl[ProgramsBillingType.TravelBilling] + '/programs', name: ProgramsBillingName[ProgramsBillingType.TravelBilling], isTravel: true, icon: 'si si-plane' },
    { type: ProgramsBillingType.RecreationalBilling, baseUrl: ProgramsBaseUrl[ProgramsBillingType.RecreationalBilling] + '/programs', name: ProgramsBillingName[ProgramsBillingType.RecreationalBilling], isRecreation: true, icon: 'si si-credit-card' },
    { type: ProgramsBillingType.CampsClinics, baseUrl: ProgramsBaseUrl[ProgramsBillingType.CampsClinics] + '/programs', name: ProgramsBillingName[ProgramsBillingType.CampsClinics], isCamps: true, icon: 'si si-grid' },
  ];
  navEnabled: any = {};
  adminAccount: Observable<boolean>;

  eventsPageID: number;

  isMyPlayerProfileSelected = false;
  isCollegesViewsSelected = false;
  isCollegeAttendanceSelected: boolean;
  isSafeSportTrainingActive: boolean;

  constructor(
    private activeRoute: ActivatedRoute,
    public router: Router,
    private leftNavigationService: LeftNavigationService,
    private store: Store<any>,
    private assoService: AssociationRegistrationService,
    private clubEventService: ClubEventsService,
    private collegeRecrutingCenterService: CollegeRecrutingCenterService,
    public alertService: AlertService
  ) {
    this.ProgramTypeId = 0.1;

    this.store.select(AppFields.App, AppFields.TeamAccount).subscribe(p => {
      this.teamAccount = p;
    });

    Promise.resolve().then(() => {
      this.adminAccount = combineLatest(
        this.store.select(AppFields.App, AppFields.TeamAccount),
        this.store.select(AppFields.App, AppFields.MyTeam),
        this.store.select(AppFields.App, AppFields.BillingTypeID),
        (t, m, typeID) => typeID === ProgramsBillingType.TeamBilling || (!t && !m && !!StorageUtil.clubID)
      );
    });

    this.staffEvaluations = this.store.select(AppFields.App, AppFields.EvalautionAccount);
    this.store.select(AppFields.App, AppFields.EvalautionAccount).subscribe(rs => {
      this.isTeamAccount = rs;
    });

    this.subscription.add(this.store.select(AppFields.App, AppFields.Program).subscribe(p => {
      this.program = p;
    }));

    this.subscription.add(this.store.select(AppFields.App, AppFields.BillingTypeID).subscribe(id => {
      setTimeout(() => {
        this.typeId = id;
        this.programsOpened = id <= ProgramsBillingType.CampsClinics;
      });
    }));

    this.user = this.store.select(AppFields.App, AppFields.User);


    this.selectedOrg = this.store.select(Fields.Module, Fields.SelectedOrg);
    this.selectedPastOrg = this.store.select(Fields.Module, Fields.SelectedPastOrg);
    this.selectedTeam = this.store.select(Fields.Module, Fields.SelectedTeam);

    //Club / Team has any Subscription Plan
    this.store.select(AppFields.App, AppFields.SubscriptionPlans).subscribe((rs: any) => {
      this.subscriptionPlans = rs;
      //this.clubPlans = rs;
      setTimeout(() => {
        if (!this.subscriptionPlans) {
          //if (!this.clubPlans) {
          this.getSubscriptionPlans();
        }
      }, 5000);
    });
    //this.clubTeamHasCollegeRecruitingPlan = this.store.select(AppFields.App, AppFields.ClubCollegeRecruiting);

    let clubID;

    //checkChildClub
    this.store
      .select(AppFields.App, AppFields.Club)
      .pipe(
        filter(c => !!c),
        switchMap(
          c =>
            c &&
            c.clubID &&
            ((clubID = c.clubID), this.assoService.checkChildClub(c.clubID))
        )
      )
      .pipe(take(1))
      .subscribe(r => (this.isChildClub = r));

    //checkIsOrgClub
    this.store
      .select(AppFields.App, AppFields.Club)
      .pipe(
        filter(c => !!c),
        switchMap(
          c =>
            c &&
            c.clubID &&
            ((clubID = c.clubID), this.clubEventService.checkIsOrgClub(c.clubID))
        )
      )
      .pipe(take(1))
      .subscribe(r => (this.isECNLEventClub = r));

    //checkClubSportIsBasketball
    this.store
      .select(AppFields.App, AppFields.Club)
      .pipe(
        filter(c => !!c),
        switchMap(
          c =>
            c &&
            c.clubID &&
            ((clubID = c.clubID),
              this.assoService.checkClubSportIsBasketball(c.clubID))
        )
      )
      .pipe(take(1))
      .subscribe(r => (this.isBasketballClub = r));

    //My Team - Team Account
    this.store.select(AppFields.App, AppFields.MyTeam).subscribe(team => {
      this.myTeam = team;
    });

    //College Recruiting Player
    this.store.select(AppFields.App, AppFields.CollegeRecruitingPlayer).subscribe(player => {
      this.collegeRecPlayer = player;
    });
  }

  ngOnInit() {
    this.currentUrl = this.router.url;
    this.routeParams = this.activeRoute.snapshot.params;

    this.assoService.checkChildClub(+localStorage.getItem('clubID'));
    this.menuOpened = new Array(3).fill(false);
    //this.checkedIsOrgEvent();
    /* Fixed: same page refresh content. (tempory archive) */
    this.router.routeReuseStrategy.shouldReuseRoute = function (
      future: ActivatedRouteSnapshot,
      curr: ActivatedRouteSnapshot
    ) {
      return false;
    };

    if (
      window.location.href.includes('http://clubbilling.dev') ||
      window.location.href.includes('localhost:')
    ) {
      this.urlRedirect =
        'http://dev.totalglobalsports.com/ClubDirector/ClubDashboard.aspx';
    }

    /* Left Nav Properties. */
    this.subscription.add(this.leftNavigationService
      .getLeftNav()
      .subscribe((navObject: any) => {
        console.log('navObject(tryout):', navObject);
        const slug = navObject.ProgramName.toLowerCase()
          .trim()
          .replace(/[^a-z0-9\s-]/g, ' ')
          .replace(/[\s-]+/g, '-');
        this.ProgramId = navObject.ProgramId;
        this.ProgramTypeId = navObject.ProgramTypeId;
        this.ProgramName = slug;
        if (navObject.ProgramStatus === 0) {
          this.ProgramStatus = 'inactive';
        } else if (navObject.ProgramStatus === 1) {
          this.ProgramStatus = 'active';
        } else if (navObject.ProgramStatus === 2) {
          this.ProgramStatus = 'archive';
        }
      }));

    this.subscription.add(
      this.router.events
        .pipe(filter(e => e instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          if (event.url.startsWith('staff/all/evaluations')) {
            this.typeId = 9;
          } else if (event.url.startsWith('/club-injury')) {
            // this.typeId = 0;
            this.hideAllMenu();
            this.healthOpened = true;
            this.clear();
          } else if (event.url.startsWith('/club-evaluation') || (event.url.startsWith('/high-five-success/Evaluations'))) {
            this.typeId = 0;
            this.hideAllMenu();
            this.evaluationsOpened = true;
            this.clear();
            if (event.url.startsWith('/club-evaluation/templates') || event.url.startsWith('/club-evaluation/details')) {
              this.evaluationTemplatesSelected = true;
            } else {
              this.evaluationTemplatesSelected = false;
            }
          } else if (event.url.startsWith('/club-scheduler')) {
            this.hideAllMenu();
            this.clubOpened = true;
            this.clubCalendarOpened = true;
          } else if (event.url.startsWith('/club')) {
            this.typeId = 0;
            this.hideAllMenu();
            this.clear();
            if (this.collegeRecPlayer) {
              this.recruitingCenterOpened = true;
              this.collegeRecruitingOpened = true;
              this.clubOpened = false;
            } else {
              this.clubOpened = true;
            }
          } else if (event.url.startsWith('/communication')) {
            this.hideAllMenu();
            this.communicationCenterOpened = true;
            this.typeId = 0;
            this.clear();
            if (event.url.startsWith('/communication-center/campaign-dashboard') || event.url.startsWith('/communication-center/emails') || event.url.startsWith('/communication-center/automated-email') ||
              event.url.startsWith('/communication-center/campaign')) {
              this.emailCampaignCommunicationOpened = true;
            } else if (event.url.startsWith('/communication-center/mobile-app-dashboard') || event.url.startsWith('/communication-center/messages') || event.url.startsWith('/communication-center/articles')) {
              this.clubMobileCommunicationOpened = true;
            }
          } else if (event.url.startsWith('/team-admin')) {
            this.hideAllMenu();
            if (event.url.startsWith('/team-admin/team/self-games') || event.url.startsWith('/team-admin/team/past-games') ||
              event.url.startsWith('/team-admin/team/practice') || event.url.startsWith('/team-admin/team/other-event')) {
              this.teamSchedulePage = true;
            }
            if (event.url.endsWith('/player-mood')) {
              this.healthOpened = true;
              this.moodSelected = true;
              this.selectedWorkoutPlanUrl = null;
            } else if (event.url.endsWith('/development-calendar')) {
              this.healthOpened = true;
              this.developmentCalendarOpened = true;
              this.selectedWorkoutPlanUrl = null;
            } else if (event.url.endsWith('/game-survey')) {
              this.healthOpened = true;
              this.gameSurveySelected = true;
              this.selectedWorkoutPlanUrl = null;
            } else if (event.url.includes('/college-center/')) {
              this.collegeCenterOpened = true;
              if (event.url.endsWith('/dashboard')) {
                this.teamCollegeRecruitingOpened = true;
              }
            }
          } else if (StorageUtil.roleId && StorageUtil.teamId &&
            StorageUtil.userID && StorageUtil.clubID &&
            event.url.startsWith('/team-injury')) {
            this.healthOpened = true;
            this.injurySelected = true;
            this.developmentCalendarSelected = false;
            this.selectedWorkoutPlanUrl = null;
          } else if (StorageUtil.roleId && StorageUtil.teamId &&
            StorageUtil.userID && StorageUtil.clubID &&
            event.url.startsWith('/team-development-calendar')) {
            this.healthOpened = true;
            this.developmentCalendarSelected = true;
            this.injurySelected = false;
            this.selectedWorkoutPlanUrl = null;
          } else if (event.url.startsWith('/events')) {
            this.clear();
            this.typeId = 0;
            this.hideAllMenu();
            this.clubEventsOpened = true;
            // Public - ECNL Events Page
            if (event.url.endsWith('/1')) { // Public Events
              this.eventsPageID = 1;
            } else if (event.url.endsWith('/2')) { // ECNL Events
              this.eventsPageID = 2;
            }
          } else if (event.url.startsWith('/financials')) {
            this.clear();
            this.typeId = 0;
            this.hideAllMenu();
            this.financialsOpened = true;
            if (event.url.includes('/financial-programs')) {
              this.financialProgramOpened = true;
            } else if (event.url.includes('/financial-events')) {
              this.financialEventsOpened = true;
            } else if (event.url.includes('/financial-facilities')) {
              this.financialFacilitiesOpened = true;
            } else if (event.url.includes('/financial-players')) {
              this.financialPlayersOpened = true;
            }

          } else if (event.url.startsWith('/college-center')) {
            this.typeId = 0;
            this.hideAllMenu();
            this.clear();
            this.collegeCenterOpened = true;
          } else if (event.url.startsWith('/association/past-season')) {
            this.clear();
            this.selectedPastOrg = this.store.select(Fields.Module, Fields.SelectedPastOrg);
            this.hideAllMenu();
            this.associationRegistration = true;
            this.pastSeason = true;
          } else if (event.url.startsWith('/association')) {
            this.selectedOrg = this.store.select(Fields.Module, Fields.SelectedOrg);
            this.hideAllMenu();
            this.associationRegistration = true;
            this.currentSeason = true;
            this.associationRegistrationOpened = true;
          } else if (event.url.startsWith('/college-recruiting') || (event.url.startsWith('/high-five-success/CollegeRecruting'))) {
            this.hideAllMenu();
            if (event.url.startsWith('/college-recruiting/dashboard')) {
              this.store.select(AppFields.App, AppFields.SubscriptionPlans).subscribe((rs: any) => {
                this.subscriptionPlans = rs;
                //this.clubPlans = rs;
              });
            }

            this.collegeRecruitingOpened = true;
            this.recruitingCenterOpened = true;
            this.typeId = 0;
            this.clear();

            if (event.url.includes('/players/') || event.url.includes('/myplayerprofile/')) {
              this.isMyPlayerProfileSelected = true;
            } else {
              this.isMyPlayerProfileSelected = false;
            }

            this.isCollegesViewsSelected = false;
            if (event.url.startsWith('/college-recruiting/colleges') || event.url.startsWith('/college-recruiting/college-')) {
              this.isCollegesViewsSelected = true;
              this.teamCollegeRecruitingOpened = true;
            }
            else if (
              event.url.includes('/college-recruiting/communication') ||
              event.url.includes('/college-recruiting/players') ||
              event.url.includes('/college-recruiting/club-player-favorites') ||
              event.url.includes('/college-recruiting/commitment')) {
              this.teamCollegeRecruitingOpened = true;
            }
            else if (event.url.includes('/college-recruiting/pamphlet') || event.url.includes('/college-recruiting/attendance') || event.url.includes('/college-recruiting/share-code')) {
              this.collegeCheckInOpened = true;
            }

          } else if (event.url.startsWith('/player')) {
            this.hideAllMenu();
            this.typeId = 0;
            this.clear();
          } else if (event.url.startsWith('/workouts')) {
            this.hideAllMenu();
            this.workoutsOpened = true;
            this.clear();
            if (event.url.includes('/plans') && !event.url.endsWith('/plans') &&
              !event.url.endsWith('/players') && !event.url.endsWith('/leaderboard')) {
              this.selectedWorkoutPlanUrl = event.url.split('/').slice(0, 5).join('/');
            } else if (event.url.includes('/plans') &&
              (event.url.endsWith('/players') || event.url.endsWith('/leaderboard'))) {
            } else {
              this.selectedWorkoutPlanUrl = null;
            }
          } else if (event.url.startsWith('/team-programs') || (event.url.startsWith('/team-billing'))) {
            this.hideAllMenu();
            this.programsOpened = true;
            this.teamProgramsOpened = true;
            this.clear();
          } else if (event.url.startsWith('/video-center')) {
            this.hideAllMenu();
            this.videoCenterOpened = true;
          } else if (event.url.startsWith('/safesport')) {
            this.store.select(AppFields.App, AppFields.SelectedOrgSeason).subscribe(
              (rs) => {
                this.selectedOrgSeason = rs;
              }
            );
            this.hideAllMenu();
            this.isSafeSportTrainingActive = true;
            this.isSafeSportInfo = true;
            if (event.url.includes('/training-players') || event.url.includes('/sor-review')) {
              this.isSafeSportInfoPlayer = true;
            }
            if (event.url.includes('/safesport-documents')) {
              this.isSafeSportInfoStaff = true;
            }
          } else {
            this.hideAllMenu();
            this.programsOpened = true;
          }
        })
    );

    this.user.pipe(filter(u => !!u), take(1)).subscribe(u => {
      this.navEnabled = {
        Club: lodash.intersection(
          u.clubUserRoles,
          [EStaffRoles.ExecutiveDirector, EStaffRoles.CoachingDirector, EStaffRoles.ClubRegistrar, EStaffRoles.ClubDirector]
        ).length > 0,
        Programs: lodash.intersection(
          u.clubUserRoles,
          [EStaffRoles.ExecutiveDirector, EStaffRoles.ClubRegistrar, EStaffRoles.ClubDirector]
        ).length > 0,
        Tournaments: lodash.intersection(
          u.clubUserRoles,
          [EStaffRoles.ExecutiveDirector, EStaffRoles.CoachingDirector, EStaffRoles.ClubRegistrar, EStaffRoles.ClubDirector]
        ).length > 0,
        Financials: lodash.intersection(
          u.clubUserRoles,
          [EStaffRoles.ExecutiveDirector, EStaffRoles.FinancialAdmin]
        ).length > 0,
        CollegeRecruting: lodash.intersection(
          u.clubUserRoles,
          [EStaffRoles.ExecutiveDirector, EStaffRoles.CoachingDirector, EStaffRoles.CollegeRecruiter, EStaffRoles.ClubDirector]
        ).length > 0,
        VideoCenter: lodash.intersection(
          u.clubUserRoles,
          [EStaffRoles.ExecutiveDirector, EStaffRoles.CoachingDirector, EStaffRoles.ClubDirector]
        ).length > 0,
        Eval: lodash.intersection(
          u.clubUserRoles,
          [EStaffRoles.ExecutiveDirector, EStaffRoles.CoachingDirector, EStaffRoles.ClubDirector,
          EStaffRoles.TeamAdmin, EStaffRoles.HeadCoach, EStaffRoles.KeeperCoach, EStaffRoles.AssistantCoach, EStaffRoles.NoRoleAssigned]
        ).length > 0,
        TestingCenter: lodash.intersection(
          u.clubUserRoles,
          [EStaffRoles.ExecutiveDirector, EStaffRoles.CoachingDirector, EStaffRoles.ClubDirector]
        ).length > 0,
        CommunicationCenter: lodash.intersection(
          u.clubUserRoles,
          [EStaffRoles.ExecutiveDirector, EStaffRoles.CoachingDirector, EStaffRoles.ClubDirector, EStaffRoles.ClubRegistrar]
        ).length > 0,
        GameManager: lodash.intersection(
          u.clubUserRoles,
          [EStaffRoles.TeamAdmin, EStaffRoles.HeadCoach, EStaffRoles.KeeperCoach, EStaffRoles.AssistantCoach, EStaffRoles.NoRoleAssigned]
        ).length > 0,
      };
    });

    this.getSubscriptionPlans();
  }

  navTryoutProgram() {
    this.ProgramTypeId = 0.2;
    const routeObj = {
      Slug: '',
      ClubProgramID: '',
      ClubProgramName: '',
      Status: '',
      ClubProgramTypeID: ''
    };
    localStorage.setItem('routeObject', JSON.stringify(routeObj));
  }

  navigateToEvaluationTemplates() {
    // this.isEvaluations = true;
    this.evaluationsOpened = true;
    this.router.navigate(['/club-evaluations/templates']);
  }

  validationMessage(event: Event) {
    console.log('false');
    event.stopPropagation();
    Swal.fire('Please, select a program.', '', 'error');

    this.resetProgram();
  }

  toggleTeamBilling() {
    this.ProgramTypeId = 3;
    this.leftNavigationService.selectedTeamBillingProgram = null;
  }

  resetProgram() {
    this.store.dispatch({
      type: AppTypes.UpdateState,
      payload: {
        [AppFields.Program]: null
      }
    });

    this.ProgramTypeId = 3;
  }

  resetMyTeams() {
    localStorage.removeItem('teamId');
    localStorage.removeItem('roleId');
    localStorage.removeItem('teamGender');
    localStorage.removeItem('clubId');
    localStorage.removeItem('isShowpopup');

    this.clubHasCollegeRecruitingPlan = null;

    this.store.dispatch({
      type: AppTypes.UpdateState,
      payload: {
        [AppFields.MyTeam]: null
      }
    });

    this.store.dispatch({
      type: AppTypes.UpdateState,
      payload: {
        [AppFields.SubscriptionPlans]: null
      }
    });

    this.router.navigate(['/team-admin/my-teams']);
  }

  get teamUrlRedirect(): string {
    return environment.teamUrlRedirect + StorageUtil.teamId;
  }

  get isAssociation(): boolean {
    return this.router.url.startsWith('/association');
  }

  get isEvaluations(): boolean {
    return this.router.url.startsWith('/club-evaluations');
  }

  get teamId(): number {
    return StorageUtil.teamId;
  }

  get myTeams(): boolean {
    return (
      this.myTeam
    );
  }

  hideAllMenu() {
    this.clubOpened = false;
    this.clubCalendarOpened = false;
    this.programsOpened = false;
    this.communicationCenterOpened = false;
    this.associationRegistration = false;
    this.communicationEmail = false;
    this.emailCampaignCommunicationOpened = false;
    this.clubMobileCommunicationOpened = false;
    this.clubEventsOpened = false;
    this.financialsOpened = false;
    this.financialProgramOpened = false;
    this.financialEventsOpened = false;
    this.financialFacilitiesOpened = false;
    this.financialPlayersOpened = false;
    this.collegeCenterOpened = false;
    this.collegeCheckInOpened = false;
    this.teamCollegeRecruitingOpened = false;
    this.recruitingCenterOpened = false;
    this.evaluationsOpened = false;
    this.associationRegistrationOpened = false;
    this.collegeRecruitingOpened = false;
    this.workoutsOpened = false;
    this.teamProgramsOpened = false;
    this.healthOpened = false;
    this.injurySelected = false;
    this.developmentCalendarSelected = false;
    this.videoCenterOpened = false;
    this.moodSelected = false;
    this.gameSurveySelected = false;
    this.developmentCalendarOpened = false;
    this.currentSeason = false;
    this.pastSeason = false;
    this.isSafeSportTrainingActive = false;
    this.isSafeSportInfo = false;
    this.isSafeSportInfoPlayer = false;
    this.isSafeSportInfoStaff = false;
  }

  clear() {
    this.selectedOrg = null;
    this.selectedPastOrg = null;
  }

  closeHealthOpened() {
    this.clear();
    this.hideAllMenu();
    this.healthOpened = !this.healthOpened;
    this.workoutsOpened = !this.workoutsOpened;
    // this.injurySelected = !this.injurySelected;
  }

  collegeCenterMenueOpened() {
    this.clear();
    this.hideAllMenu();
    this.store.select(AppFields.App, AppFields.SubscriptionPlans).subscribe((rs: any) => {
      this.subscriptionPlans = rs;
      //this.clubPlans = rs;
    });
    //this.store.select(AppFields.App, AppFields.TeamSubscriptionPlans).subscribe((rs: any) => {
    //  this.teamPlans = rs;
    //});
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if (event.url.startsWith('/college-recruiting')) {
          this.collegeCenterOpened = true;
        }
      });

    this.collegeCenterOpened = !this.collegeCenterOpened;
    this.recruitingCenterOpened = !this.recruitingCenterOpened;
  }

  getSubscriptionPlans() {
    setTimeout(() => {
      if (!this.subscriptionPlans) {
        //if (!this.clubPlans) {
        if (StorageUtil.clubID) {
          this.collegeRecrutingCenterService.getClubTeamSubscriptionPlansWithPlanName(StorageUtil.clubID, StorageUtil.teamId || 0).subscribe((rs: any) => {
            this.subscriptionPlans = rs;
            //this.clubPlans = rs;
            this.store.dispatch({
              type: AppTypes.UpdateState,
              payload: {
                [AppFields.SubscriptionPlans]: rs
              }
            });
          });
        }
      }
    }, 5000);
  }

  get showTeamAccount(): Observable<boolean> {
    return this.user.pipe(
      map(u => u && u.userRoles.indexOf(EStaffRoles.TeamAdmin) > -1)
    );
  }

  get isDev() {
    return !environment.production;
  }

  getSlug(name): string {
    return name.toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, ' ')
      .replace(/[\s-]+/g, '-');
  }

  showUpgradePlanPopup() {
    this.alertService.info('To use the feature, you must upgrade your account.');
  }

  onLogoClick() {
    if (this.isTeamAccount) {
      this.router.navigate(['/team-admin/my-teams']);
    }
    else {
      this.router.navigate(['/programs/active']);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/nav-left/nav-left.component.ts